module.exports = __webpack_public_path__ + "img/no-lesson.c806bd70.png";